export const getFormData = (url) => {
  if(process.env.REACT_APP_IS_TESTORDER === "true") {
    const testOrder = require('./testOrder').default
    return new Promise(resolve => {
      // console.log('inint test order', testOrder)
      setTimeout(() => {
        resolve(testOrder);
      }, 300);
    })
  }


  let init = {};
  if (process.env.REACT_APP_IS_STAGING !== "true") {
    init = {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    };
  }

  return fetch(url, init).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      return res?.statusText;
    }
  });
};

let host = "";
if (process.env.REACT_APP_IS_STAGING === "true") {
  host = "http://staging-pcs.travelbusinessclass.com";
}

export const GET_OFFER_BASE_URL = `${host}/api/get/`;

export const POST_OFFER_BASE_URL = `${host}/api/store/`;

export const VIEW_FORM_BASE_URL = `${host}/api/view/`;

export const GET_EXPENSE_BASE_URL = `${host}/api/getProductOffer/`; // TODO:
export const GET_EXPENSE_PREVIEW_BASE_URL = `${host}/api/getProductOfferPreview/`; // TODO:
